/**
 * Application entry point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import './styles/tailwind.css';
import { initErrorTracking } from './lib/errorTracking';

// Initialize error tracking early (non-blocking)
initErrorTracking().catch((err) => {
  console.warn('Failed to initialize error tracking:', err);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary name="Root">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
